.header {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin-bottom: var(--space-6);
}

.withTabs {
  margin-bottom: var(--space-5);
}

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
}

.headings {
  display: flex;
  flex-direction: column;
  gap: var(--space-1-5);
  flex: 1 1 20rem;
  min-width: 0;
}

.titleRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2) var(--space-3);
}

.title {
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-tight);
}

.meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}

.description {
  max-width: 60rem;
  color: var(--color-text-muted);
  font-size: var(--font-size-md);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}

.tabs {
  margin-top: var(--space-1);
}

@media (max-width: 640px) {
  .title {
    font-size: var(--font-size-2xl);
  }

  .actions {
    width: 100%;
  }
}
